import { useTranslation } from 'react-i18next'

import { weekNumber } from 'weeknumber'

import { DateBodyTemplate } from './DateBodyTemplate'

export const ForecastDateBodyTemplate = (
  date?: string | Date,
  dateFormat?: string,
) => {
  const { i18n } = useTranslation()
  const { language } = i18n

  // if the item was rejected or no date is available show no date
  if (!date || !dateFormat) {
    return <></>
  }

  // format date
  function formatDate(dateString: string | Date, formatDateString: string) {
    const dateObject = new Date(dateString)

    if (formatDateString?.toLowerCase() === 'month') {
      let dateOptionsMonth: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: '2-digit',
      }

      const formattedDate = dateObject.toLocaleDateString(
        language,
        dateOptionsMonth,
      )

      return formattedDate
    } else {
      const weekNo = weekNumber(dateObject)

      if (language.toLowerCase() === 'de') {
        const formattedDate =
          weekNo < 10
            ? '0' + weekNo + '.' + dateObject.getFullYear().toString() + ' (KW)'
            : weekNo + '.' + dateObject.getFullYear().toString() + ' (KW)'

        return formattedDate
      }

      const formattedDate =
        weekNo < 10
          ? '0' + weekNo + '/' + dateObject.getFullYear().toString() + ' (CW)'
          : weekNo + '/' + dateObject.getFullYear().toString() + ' (CW)'

      return formattedDate
    }
  }

  if (dateFormat.toLowerCase() === 'day') {
    return DateBodyTemplate(date)
  }

  // otherwise show a formatted date
  return <>{formatDate(date, dateFormat!)}</>
}
